// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h3-a";
export var fulfillmentFormRail = "_h3-9";
export var headerTitleRow = "_h3-c";
export var orderDetailsWrapper = "_h3-7";
export var orderLinkTrigger = "_h3-2";
export var paymentInformationGrid = "_h3-h";
export var paymentSummaryColumn = "_h3-i";
export var shipmentContainer = "_h3-b";
export var shipmentDetailsMainPane = "_h3-8";
export var shipmentNavigationCard = "_h3-5";
export var shipmentNavigationRail = "_h3-3";
export var shipmentNavigationRailHeader = "_h3-4";
export var shipmentSummaryFact = "_h3-e";
export var shipmentSummaryGrid = "_h3-d";
export var shipmentSummaryMetadataRow = "_h3-f";
export var shipmentSummaryTags = "_h3-g";
export var shipmentWorkspace = "_h3-0";
export var shipmentWorkspaceContent = "_h3-6";
export var shipmentWorkspaceHeader = "_h3-1";